var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"traveller"},[_c('img',{attrs:{"alt":"vándornapló_vándor","src":_vm.image}}),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }